export default "__VITE_ASSET__43a2383d__"